<template>
  <div>
  <div class="home-container">

    <BlogHeader :initialKeyword="searchKeyword"  @search="handleSearchFromHeader" />

    <main class="main-content">
      <aside class="sidebar">
        <div class="sidebar-section">
          <h3>近期文章</h3>
          <ul class="recent-articles">
            <li v-for="article in recentArticles" :key="article.id">
              <a @click="goArticle(article.id)">{{ article.title }}</a>
            </li>
          </ul>
        </div>

        <div class="sidebar-section">
          <h3>按时间分类</h3>
          <div class="archive-tree">
            <div v-for="(yearData, year) in groupedArchiveData" :key="year">
              <span class="year" @click="toggleYear(year)">{{ year }}年</span>
              <div v-if="expandedYears.includes(year)">
                <span 
                  v-for="monthData in yearData" 
                  :key="monthData.month"
                  class="month" 
                  @click="filterByDate(year, monthData.month)"
                >
                  {{ monthData.month }}月 ({{ monthData.count }})
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="sidebar-section">
          <h3>博客分类</h3>
          <ul class="category-list">
            <li v-for="category in categories" :key="category.id">
              <a @click="filterByCategory(category.id)">{{ category.name }}</a>
            </li>
          </ul>
        </div>

        <div class="sidebar-section">
          <h3>标签</h3>
          <div class="tag-cloud">
            <el-tag 
              v-for="tag in tags" 
              :key="tag.id" 
              size="small" 
              @click="filterByTag(tag.id)"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </div>
      </aside>

      <section class="article-list">
        <div class="filter-bar">
          <div class="filter-item">
              <span class="filter-label">分类：</span>
              <el-select size="small" clearable
                v-model="filterCategory" 
                placeholder="选择分类" 
                @change="handleFilterChange"
              >
                <el-option label="全部" :value="''"></el-option>
                <el-option 
                  v-for="cat in categories" 
                  :key="cat.id" 
                  :label="cat.name" 
                  :value="cat.id"
                ></el-option>
              </el-select>
          </div>
          <div class="filter-item">
              <span class="filter-label">标签：</span>
              <el-select size="small" clearable
                v-model="filterTag" 
                placeholder="选择标签" 
                @change="handleFilterChange"
              >
                <el-option label="全部" :value="''"></el-option>
                <el-option 
                  v-for="tag in tags" 
                  :key="tag.id" 
                  :label="tag.name" 
                  :value="tag.id"
                ></el-option>
              </el-select>
          </div>
          <el-button-group class="sort-btns">
            <el-button :type="sortBy.startsWith('time') ? 'primary' : 'default'" size="small" @click="sortByTime">
              <i class="el-icon-date" /> 发布时间 <i :class="sortBy.startsWith('time') ? (sortBy === 'time_desc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom') : ''" style="margin-left:2px" />
            </el-button>
            <el-button :type="sortBy.startsWith('read') ? 'primary' : 'default'" size="small" @click="sortByRead">
              <i class="el-icon-view" /> 阅读量 <i :class="sortBy.startsWith('read') ? (sortBy === 'read_desc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom') : ''" style="margin-left:2px" />
            </el-button>
          </el-button-group>
        </div>

        <div v-if="articles.length > 0" class="article-list-container masonry">
          <article 
            v-for="article in articles" 
            :key="article.id" 
            class="article-card"
            @click="goArticle(article.id)"
          >
            <div class="article-card-body">
              <h2 class="article-title">{{ article.title }}</h2> 
              <div class="article-meta">
                <span v-if="article.category" class="category">{{ article.category.name }}</span>
                <span class="time">{{ formatDate(article.createdAt) }}</span>
              </div>
              <p class="article-summary">{{ article.summary || truncateContent(article.content) }}</p>
            </div>
            <div v-if="article.publishType === 'video' && article.videoUrl" class="article-card-cover">
              <video 
                :src="article.videoUrl" 
                controls
                playsinline
                autoplay
                muted
                loop
                preload="metadata"
              ></video>
            </div>
            <div v-else-if="article.coverImage" class="article-card-cover">
              <img :src="article.coverImage" :alt="article.title" />
            </div>
            <div class="article-card-footer">
              <div class="article-tags">
                <el-tag v-for="tag in getArticleTags(article.tagIds)" :key="tag.id" size="mini">
                  {{ tag.name }}
                </el-tag>
              </div>
              <div class="article-stats">
                <span class="stat-item">
                  <i class="el-icon-view stat-icon"></i> {{ article.readCount }}
                </span>
                <span class="stat-item">
                  <i class="el-icon-chat-dot-square stat-icon"></i> {{ article.commentCount }}
                </span>
                <span class="stat-item">
                  <i class="like-icon-sm stat-icon"></i> {{ article.likeCount }}
                </span>
                <span class="stat-item share-btn" @click.stop="openShareModal(article)">
                  <i class="el-icon-share stat-icon"></i>
                </span>
              </div>
            </div>
          </article>
        </div>

        <div v-else class="empty-state">
          <el-empty description="暂无文章"></el-empty>
        </div>

        <el-pagination
          v-if="total > 0"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handlePageChange"
          layout="prev, pager, next, jumper"
        ></el-pagination>
      </section>
    </main>

   

    <ShareModal
      :visible="shareModalVisible"
      :title="shareArticle?.title"
      :url="shareUrl"
      :description="shareArticle?.summary"
      @close="closeShareModal"
    />
  </div>

     
  <Footer />
  </div>

</template>

<script>
import BlogHeader from '@/components/BlogHeader.vue'
import ShareModal from '@/components/ShareModal.vue'
import Footer from '@/components/Footer/index.vue'
import { getPublishedArticles, getCategories, getTags, getRecentArticles, getArchiveData, searchArticles } from '@/api/blog'

export default {
  name: 'Home',
  components: {
    BlogHeader,
    ShareModal,
    Footer
  },
  data() {
    return {
      articles: [],
      categories: [],
      tags: [],
      recentArticles: [],
      archiveData: [],
      expandedYears: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchKeyword: '',
      filterCategory: '',
      filterTag: '',
      filterYear: '',
      filterMonth: '',
      sortBy: 'time_desc',
      shareModalVisible: false,
      shareArticle: null
    }
  },
  computed: {
    groupedArchiveData() {
      const grouped = {}
      this.archiveData.forEach(item => {
        if (!grouped[item.year]) {
          grouped[item.year] = []
        }
        grouped[item.year].push({ month: item.month, count: item.count })
      })
      return grouped
    },
    shareUrl() {
      if (!this.shareArticle) return ''
      return `${window.location.origin}/article/${this.shareArticle.id}`
    }
  },
  mounted() {
    // 从 URL 查询参数中读取筛选条件
    if (this.$route.query.categoryId) {
      this.filterCategory = parseInt(this.$route.query.categoryId)
    }
    if (this.$route.query.tagId) {
      this.filterTag = parseInt(this.$route.query.tagId)
    }
    if (this.$route.query.keyword) {
      this.searchKeyword = this.$route.query.keyword
    }
    this.loadData()
    this.loadSidebarData()
  },
  methods: {
    async loadData() {
      try {
        const params = {
          page: this.currentPage - 1,
          size: this.pageSize,
          sort: this.sortBy
        }
        if (this.searchKeyword) params.keyword = this.searchKeyword
        if (this.filterCategory) params.categoryId = this.filterCategory
        if (this.filterTag) params.tagId = this.filterTag
        if (this.filterYear && this.filterMonth) {
          params.startDate = `${this.filterYear}-${String(this.filterMonth).padStart(2, '0')}-01T00:00:00`
          params.endDate = `${this.filterYear}-${String(this.filterMonth).padStart(2, '0')}-28T23:59:59`
        }
        
        const response = this.searchKeyword || this.filterCategory || this.filterTag || (this.filterYear && this.filterMonth)
          ? await searchArticles(params)
          : await getPublishedArticles(params.page, params.size, params.sort)
        
        this.articles = response.data.content
        this.total = response.data.totalElements
      } catch (error) {
        console.error('Failed to load articles:', error)
      }
    },
    async loadSidebarData() {
      try {
        const [categoriesRes, tagsRes, recentRes, archiveRes] = await Promise.all([
          getCategories(),
          getTags(),
          getRecentArticles(),
          getArchiveData()
        ])
        this.categories = categoriesRes.data
        this.tags = tagsRes.data
        this.recentArticles = recentRes.data
        this.archiveData = archiveRes.data
      } catch (error) {
        console.error('Failed to load sidebar data:', error)
      }
    },
    handleSearchFromHeader(keyword) {
      this.searchKeyword = keyword
      this.currentPage = 1
      this.loadData()
    },
    handleSearchKeyup(event) {
      if (event.keyCode === 13) {
        this.handleSearch()
      }
    },
    handleSearch() {
      console.log(11111)
      this.currentPage = 1
      this.loadData()
    },
    handleFilterChange() {
      this.currentPage = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    sortByTime() {
      this.sortBy = this.sortBy === 'time_desc' ? 'time_asc' : 'time_desc'
      this.currentPage = 1
      this.loadData()
    },
    sortByRead() {
      this.sortBy = this.sortBy === 'read_desc' ? 'read_asc' : 'read_desc'
      this.currentPage = 1
      this.loadData()
    },
    filterByCategory(id) {
      this.filterCategory = id
      this.filterTag = ''
      this.currentPage = 1
      this.loadData()
    },
    filterByTag(id) {
      this.filterTag = id
      this.filterCategory = ''
      this.currentPage = 1
      this.loadData()
    },
    filterByDate(year, month) {
      this.filterYear = year
      this.filterMonth = month
      this.currentPage = 1
      this.loadData()
    },
    toggleYear(year) {
      const index = this.expandedYears.indexOf(year)
      if (index > -1) {
        this.expandedYears.splice(index, 1)
      } else {
        this.expandedYears.push(year)
      }
    },
    goArticle(id) {
      this.$router.push(`/article/${id}`)
    },
    goHome() {
      this.$router.push('/').catch(() => {})
    },
    goCategories() {
      this.$router.push('/categories').catch(() => {})
    },
    goTags() {
      this.$router.push('/tags').catch(() => {})
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    truncateContent(content) {
      if (!content) return ''
      const text = content.replace(/<[^>]*>/g, '')
      return text.length > 100 ? text.substring(0, 100) + '...' : text
    },
    getArticleTags(tagIds) {
      if (!tagIds) return []
      const ids = tagIds.split(',').map(id => parseInt(id))
      return this.tags.filter(tag => ids.includes(tag.id))
    },
    openShareModal(article) {
      this.shareArticle = article
      this.shareModalVisible = true
    },
    closeShareModal() {
      this.shareModalVisible = false
    }
  }
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  max-width: 1000px;
  margin: 2rem auto;
  display: flex;
  gap: 1.2rem;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1.5rem;
}

.sidebar {
  width: 280px;
  flex-shrink: 0;
}

.sidebar-section {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.sidebar-section h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
  color: #374151;
}

.recent-articles {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.recent-articles li {
  margin-bottom: 0.75rem;
  width: 100%;
  max-width: 100%;
}

.recent-articles a {
  color: #374151;
  text-decoration: none;
  font-size: 0.9rem;
  line-height: 1.4;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.recent-articles a:hover {
  color: #3b82f6;
}

.archive-tree {
  font-size: 0.9rem;
}

.archive-tree .year {
  display: block;
  color: #374151;
  font-weight: 500;
  cursor: pointer;
  padding: 0.25rem 0;
}

.archive-tree .month {
  display: block;
  color: #6b7280;
  padding: 0.25rem 0 0.25rem 1rem;
  cursor: pointer;
}

.archive-tree .month:hover {
  color: #3b82f6;
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.category-list li {
  margin-bottom: 0.5rem;
  width: 100%;
  max-width: 100%;
}

.category-list a {
  color: #374151;
  text-decoration: none;
  font-size: 0.9rem;
  cursor: pointer;
  max-width: 100%;
  display: inline-block;
}

.category-list a:hover {
  color: #3b82f6;
}

.tag-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
}

.tag-cloud .el-tag {
  background: white;
  cursor: pointer;
}
.tag-cloud .el-tag:hover {
  background: #dbeafe;
  cursor: pointer;
}

/* 核心修改：右侧文章列表区域撑满 */
.article-list {
  flex: 1;
  min-width: 0;
  width: 0; /* 配合 flex:1 强制撑满 */
}

.filter-bar {
  display: flex;
  /* gap: 1rem; */
  margin-bottom: 1rem;
  align-items: center;
  background: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  flex-wrap: wrap;
}

.filter-item{
  display: flex;
  align-items: center;
  margin-right: 2rem;
}

.article-list-container {
  width: 100%;
}

.article-list-container.masonry {
  /** 瀑布流1列布局 */
  column-count: 2;
  column-gap: 1.25rem;
  column-fill: balance;
}

.article-list-container.masonry .article-card {
  break-inside: avoid;
  display: inline-block;
  width: 100%;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.filter-bar .el-select {
  width: 150px;
}

.article-card {
  background: white;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.article-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.article-card-body {
  flex: 1;
  padding: 1.5rem;
  min-width: 0;
}

.article-card-cover {
  width: 100%;
  padding: 0 1rem;
}

.article-card-cover img,
.article-card-cover video {
  width: 100%;
  height: auto;
  max-height: 400px;
  display: block;
  border-radius: 8px;
}

.article-card-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.article-card-footer .article-tags {
  margin-bottom: 0.75rem;
}

.article-card-footer .article-tags .el-tag {
  background: white;
  margin-right: 8px !important;
}

.article-card-footer .article-stats {
  display: flex;
  gap: 1.5rem;
  color: #9ca3af;
  font-size: 0.875rem;
}

.article-card-footer .article-stats .share-btn {
  cursor: pointer;
  transition: color 0.2s;
}

.article-card-footer .article-stats .share-btn:hover {
  color: #409eff;
}

.article-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  color: #9ca3af;
}

.article-meta .category {
  background: #dbeafe;
  color: #1d4ed8;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
}

.article-summary {
  color: #4b5563;
  line-height: 1.6;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.empty-state {
  padding: 4rem;
  text-align: center;
}

.el-pagination {
  margin-top: 2rem;
  text-align: center;
}

/* ========== 响应式屏幕适配 ========== */

/* 大屏幕 */
@media screen and (min-width: 1400px) {
  .main-content {
    max-width: 1200px;
  }
}

/* 中等屏幕：保持两栏布局 */
@media screen and (max-width: 1024px) {
  .main-content {
    gap: 1rem;
    padding: 0 0.75rem;
  }
  
  .sidebar {
    width: 260px;
  }
  
  .article-card-body {
    padding: 1.25rem;
  }
  
  .article-title {
    font-size: 1.1rem;
  }
}

/* 平板：侧边栏移到下方，文章列表占满宽度 */
@media screen and (max-width: 768px) {
  .main-content {
    flex-direction: column-reverse;
    gap: 1.5rem;
  }

  .sidebar {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    padding: 0;
  }

  .sidebar-section {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin-bottom: 0;
    padding: 0.85rem;
    overflow: hidden;
  }
  
  .sidebar-section h3 {
    font-size: 0.95rem;
    margin-bottom: 0.75rem;
    padding-bottom: 0.4rem;
  }
  
  .recent-articles li {
    margin-bottom: 0.6rem;
  }
  
  .recent-articles a {
    font-size: 0.85rem;
  }
  
  .archive-tree {
    font-size: 0.85rem;
  }
  
  .archive-tree .year,
  .archive-tree .month {
    padding: 0.2rem 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .archive-tree .month {
    padding-left: 0.85rem;
  }
  
  .category-list li {
    margin-bottom: 0.4rem;
  }
  
  .category-list a {
    font-size: 0.85rem;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  
  .tag-cloud {
    gap: 0.4rem;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }

  .tag-cloud .el-tag {
    font-size: 12px !important;
    height: 24px !important;
    line-height: 24px !important;
    padding: 0 8px !important;
    max-width: 100%;
    word-break: break-all;
    white-space: normal;
  }
  
  .article-list {
    width: 100%;
  }
  
  .article-list-container.masonry {
    column-count: 1;
  }
  
  .article-card-body {
    padding: 1rem;
  }
  
  .article-title {
    font-size: 1rem;
  }
  
  .article-summary {
    font-size: 0.85rem;
    -webkit-line-clamp: 2;
  }
  
  .filter-bar {
    padding: 12px 16px;
  }
  
  .filter-bar .el-select {
    width: 120px;
  }
}

/* 小平板（≤ 600px）侧边栏单列 */
@media screen and (max-width: 600px) {
  .sidebar {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .article-list-container.masonry {
    column-count: 1;
  }
}

/* 手机（≤ 576px） */
@media screen and (max-width: 576px) {

  .article-list-container.masonry {
    column-count: 1;
  }

  .main-content {
    margin: 1rem auto;
    padding: 0 0.75rem;
  }
  
  .filter-bar {
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 12px;
  }
  
  .filter-item {
    flex: 1;
    min-width: 45%;
    margin-right: 0;
  }
  
  .sort-btns {
    display: none;
  }
  
  .filter-label {
    font-size: 12px;
  }
  
  .filter-bar .el-select {
    width: calc(50% - 20px);
    min-width: 100px;
  }
  
  .sort-btns {
    margin-left: auto;
  }
  
  .sort-btns .el-button {
    padding: 6px 10px;
  }
  
  .article-card {
    flex-direction: column;
  }
  
  .article-card-cover {
    width: 100%;
    height: 160px;
    padding: 0.75rem 0.75rem 0 0.75rem;
    order: -1;
  }
  
  .article-card-cover img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
  
  .article-card-body {
    padding: 0.75rem;
  }
  
  .article-title {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }
  
  .article-summary {
    font-size: 0.8rem;
    margin-bottom: 0.75rem;
  }
  
  .article-meta-container {
    gap: 0.5rem;
  }
  
  .article-meta {
    gap: 0.5rem;
    font-size: 0.7rem;
    flex-wrap: wrap;
  }
  
  .article-stats {
    gap: 0.75rem;
    font-size: 0.7rem;
  }
  
  .article-tags .el-tag {
    font-size: 10px !important;
    margin-right: 4px !important;
  }
  
  .empty-state {
    padding: 2rem;
  }
  
  .el-pagination {
    margin-top: 1rem;
  }
}

/* 小手机（≤ 375px） */
@media screen and (max-width: 375px) {
  .filter-bar .el-select {
    width: 100%;
  }
  
  .sort-btns {
    margin-left: 0;
    width: 100%;
    display: flex;
  }
  
  .sort-btns .el-button {
    flex: 1;
  }
  
  .filter-bar {
    flex-wrap: wrap;
  }
  
  .filter-item {
    flex: 1;
    min-width: 45%;
  }
  
  .article-card-cover {
    height: 140px;
  }
}
</style>